const theme = {
  primaryColor: '#FF6B38',
};

export default theme;
